import { render, staticRenderFns } from "./LimitedVideoAlertModalSection.vue?vue&type=template&id=b1427204"
import script from "./LimitedVideoAlertModalSection.vue?vue&type=script&lang=ts"
export * from "./LimitedVideoAlertModalSection.vue?vue&type=script&lang=ts"
import style0 from "./LimitedVideoAlertModalSection.vue?vue&type=style&index=0&id=b1427204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports